import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

// T-Shirts (Products)

// Adding t-shirt
const AddProductForm = () => {
  const [imageFile, setImageFile] = useState(null);
  const [ formData, setFormData ] = useState({title:'', price:''});
  const [ error, setError] = useState('');

  const handleChange = (e) => {
      const {name, value} = e.target;
      setFormData({
          ...formData,
          [name]: value
      })
  }

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imageFile) {
      setError('Please select an image');
      return;
    }

    const form = new FormData();
    form.append('title', formData.title);
    form.append('price', formData.price);
    form.append('image', imageFile);

    const res = await fetch('/admin/add-item', {
      method: 'POST',
      body: form
    });

    const data = await res.json();

    if (res.ok) {
      // refresh 
      window.location.reload();
    } else {
      setError(data.error);
    }
  }


  return (
    <form onSubmit={handleSubmit} style={{ marginBottom: "30px" }}>
        <h2>Neues Product hinzufügen</h2>
        <div className="admin-form-row">
          <div>
            <label>Name</label>
            <br />
            <input
              onChange={handleChange} 
              value={formData.title} 
              type="text"
              name="title"
              placeholder="Product name"
              required
            />
          </div>
          <div>
            <label>Preis</label>
            <br />
            <input
              onChange={handleChange} 
              value={formData.price} 
              type="text"
              name="price"
              placeholder="$0.00"
              required
            />
          </div>
          <div>
            <label>Bild</label>
            <br />
            <input
              type="file"
              accept="image/*"
              name="image"
              onChange={handleImageChange}
              required
            />
          </div>
          <div>
            <button type="submit" >
              Hinzufügen
            </button>
          </div>
          {error && <p>{error}</p>}
        </div>
    </form>
  )
}

// Listed T-shirts
const ShirtRow = ({shirt}) => {
  const handleDelete = async (id) => {
    const res = await fetch('/admin/delete-item', {
      method: 'DELETE',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ id: id })
    });
    const data = await res.json();
    if (res.ok) {
      // refresh 
      window.location.reload();
    } else {
      alert(data.error);
    }
  };

  return (
    <tr key={shirt.id} style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{ padding: "8px" }}>
        <img src={`https://herzdoktor.onrender.com/uploads/${shirt.imagepath}`} alt={shirt.title} width={60} height={60} />
      </td>
      <td style={{ padding: "8px" }}>{shirt.title}</td>
      <td style={{ padding: "8px" }}>{shirt.price}</td>
      <td style={{ padding: "8px", textAlign: "center" }}>
        <button
          onClick={() => handleDelete(shirt.id)}
          style={{
            padding: "6px 12px",
            backgroundColor: "#d9534f",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Löschen
        </button>
      </td>
    </tr>
  )
}


const ShirtsTable = () => {
  // fetching shirts from api
  const [shirts, setShirts] = useState([]);
  useEffect(() => {
      const fetchShirts = async () => {
        try {
          const res = await fetch('/api/get-shirts');
          const data = await res.json();
          console.log(data);
          setShirts(data);
        } catch (err) {
          console.error("Failed to fetch shirts:", err);
        }
    };
    
    fetchShirts();
  }, []);
  return (
    <div>
      <h3> Produkte </h3>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "2px solid #000" }}>
            <th style={{ textAlign: "left", padding: "8px" }}>Bild</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Name</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Preis</th>
            <th style={{ padding: "8px" }}></th>
          </tr>
        </thead>
        <tbody>
          {shirts.length === 0 ? (
            <tr>
              <td colSpan={4} style={{ textAlign: "center", padding: "20px" }}>
                Keine T-Shirts forhanden
              </td>
            </tr>
          ) : (
            shirts.map((shirt) => (<ShirtRow shirt={shirt} />))
          )}
        </tbody>
      </table>
    </div>
  )
}



// Orders 

const OrderTable = () => {
  // fetching shirts from api
  const [orders, setOrders] = useState([]);
  useEffect(() => {
      const fetchOrders = async () => {
        try {
          const res = await fetch('/admin/get-orders');
          const data = await res.json();
          if (Array.isArray(data)) {
            setOrders(data);
          }
          
        } catch (err) {
          console.error("Failed to fetch shirts:", err);
        }
    };
    
    fetchOrders();
  }, []);
  return (
    <div>
      <h3> Bestellungen </h3>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "2px solid #000" }}>
            <th style={{ textAlign: "left", padding: "8px" }}>Name</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Email</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Land</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Adresse</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Tür</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Zip</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Bestellung</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Anzahl</th>
            <th style={{ textAlign: "left", padding: "8px" }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
            <tr>
              <td colSpan={4} style={{ textAlign: "center", padding: "20px" }}>
                Momentan Keine Bestellungen
              </td>
            </tr>
          ) : (
            orders.map((order) => (<OrderRow order={order} />))
          )}
        </tbody>
      </table>
      </div>
  )
}

const OrderRow = ({order}) => {
  const handleComplete = async (id) => {
    const res = await fetch('/admin/complete-order', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ id: id })
    });
    const data = await res.json();
    if (res.ok) {
      // refresh 
      window.location.reload();
    } else {
      alert(data.error);
    }
  };

  return (
    <tr key={order.id} style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{ padding: "8px" }}>{order.fullname}</td>
      <td style={{ padding: "8px" }}>{order.email}</td>
      <td style={{ padding: "8px" }}>{order.country}</td>
      <td style={{ padding: "8px" }}>{order.street}</td>
      <td style={{ padding: "8px" }}>{order.door}</td>
      <td style={{ padding: "8px" }}>{order.zip}</td>
      <td style={{ padding: "8px" }}>{order.order_title}</td>
      <td style={{ padding: "8px" }}>{order.number || 1}</td>
      <td style={{ padding: "8px" }}>{order.status}</td>
      <td style={{ padding: "8px", textAlign: "center" }}>
        {order.status !== 'abgeschlossen' && (
            <button
              onClick={() => handleComplete(order.id)}
              style={{
                padding: "6px 12px",
                backgroundColor: "#d9534f",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Abgeschlossen
            </button>
          )}
      </td>
    </tr>
  )
}

const Admin = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch('/admin/check-token', { credentials: 'include' });
        if (!res.ok) {
          navigate('/store/login');
          return;
        }
        const data = await res.json();
        if (!data.authenticated) {
          navigate('/store/login');
        }
      } catch (err) {
        navigate('/store/login');
      }
    };
    checkAuth();
  }, [navigate]);

  return (
    <main style={{ padding: "20px" }}>
      <h1>Admin</h1>
      {/* Products Table */}
      <AddProductForm />
      <ShirtsTable />
      <OrderTable />
    </main>
  );
};

export default Admin;
